<template>
  <v-card flat>
    <v-dialog v-model="modalSaldo" max-width="400">
      <v-card>
        <v-card-title>
          <h2
            class="fonte"
          >Alterar saldo do usuário: {{userSelected.firstname + ' ' + userSelected.lastname}}</h2>
        </v-card-title>
        <v-card-text>
          <v-text-field box color="teal" v-model="novoSaldo" label="Digite o novo valor do saldo"></v-text-field>
           <!-- <v-text-field box color="teal" v-model="quemAddSaldo" label="Digite seu nome"></v-text-field> -->
           <v-select :items="pessoalInterno"  v-model="quemAddSaldo" ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn round :loading="isLoadingCahngeSaldo" :disabled="(isLoadingCahngeSaldo || !novoSaldo || !quemAddSaldo)"  class="fundo white--text ml-1" @click="alterarSaldo">Alterar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="novoCliente" max-width="550">
      <CriarConta @closeModal="novoCliente = false" />
    </v-dialog>

    <v-dialog v-model="modalTesteSms" max-width="350">
      <v-card class="pa-3">
        <v-card-title>
          <h1 class="fonte">Teste de envio de SMS</h1>
        </v-card-title>
        <v-card-text>
          <v-combobox v-model="testeSms.phone" :items="telefones" label="Telefones" chips clearable box multiple color="teal" hint="Digite um telefone e pressione ENTER para digitar o próximo" persistent-hint>
            <template v-slot:selection="data">
              <v-chip :selected="data.selected" close @input="remove(data.item)">
                <strong>{{ data.item }}</strong>
              </v-chip>
            </template>
          </v-combobox>
          <v-text-field box label="Texto" v-model="testeSms.text" color="teal"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-2" flat color="teal" @click="send">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title class="pa-5">
      <h1 class="fonte text-uppercase">Lista de clientes</h1>
      <v-btn round color="fundo" @click="novoCliente = true">Novo Cliente</v-btn>
      <v-spacer></v-spacer>
      <v-text-field color="blue-grey" v-model="search" append-icon="search" label="Buscar Empresa" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="usuariosInternos" :search="search" :expand="expand" item-key="_id">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ comprimeNome(props.item.firstname, props.item.lastname) }}</td>
        <td class="text-xs-left">{{ props.item.credits }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-center">
          <v-chip v-if="props.item.migrated" color="#890053" text-color="white">Migrado</v-chip>
          <v-btn color="#450029" dark @click="showDialogMigracao(props.item)" v-else>Migrar</v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn color="#458982" dark @click="showDialogReset(props.item.email)">Resetar senha</v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn color="#00453e" dark @click="modalTesteSms = true, user_token = props.item.key" icon>
            <v-icon>send</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center px-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn btn fab dark small color="fundo" v-on="on" @click="editItem(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>Editar usuário</span>
          </v-tooltip>

          <!-- <v-btn btn fab dark small color="fundo" @click="''">
            <v-icon>unfold_more</v-icon>
          </v-btn> -->

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn btn fab dark small color="fundo" v-on="on" @click="abreSaldo(props.item)">
                <v-icon>monetization_on</v-icon>
              </v-btn>
            </template>
            <span>Adicionar saldo</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:expand="props">
        <v-card flat class="pa-3">
          <h2 class="title fonte">Fornecedores</h2>
          <v-card-text>{{props.item.operator}}</v-card-text>
        </v-card>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">Sua pesquisa por: &quot;{{ search }}&quot; n&atilde;o obteve resultado</v-alert>
    </v-data-table>

    <v-dialog v-model="dialogMigracao" max-width="800">
      <v-card>
        <v-card-title class="headline" v-if="!loader">Alterando</v-card-title>
        <v-card-text v-if="!loader">
          <v-container grid-list-md text-xs-center class="ma-0 pa-0" style="max-width: 100% !important;">
            <v-layout row wrap>
              <v-flex xs4>
                <v-text-field box label="Nome" v-model="user.nome" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field box label="Email" v-model="user.email" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field box label="Telefone" v-model="user.telefone" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field box label="Senha" v-model="user.senha" color="blue-grey" @keyup.enter="criarConta" :append-icon="showPass ? 'visibility_off' : 'visibility'" :type="showPass ? 'text':'password'"
                  @click:append="showPass=!showPass"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field box label="Senha" v-model="user.senhaNovamente" color="blue-grey" @keyup.enter="criarConta" :append-icon="showPass ? 'visibility_off' : 'visibility'" :type="showPass ? 'text':'password'"
                 @click:append="showPass=!showPass"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field box label="Insira seu CPF ou CNPJ" v-model="user.cpf_cpnj" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field box label="CEP" v-model="user.cep" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs8>
                <v-text-field box label="Logradouro" v-model="user.logradouro" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field box label="Número" v-model="user.numero" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field box label="Bairro" v-model="user.bairro" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field box label="Cidade" v-model="user.cidade" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field box label="Estado" v-model="user.estado" color="blue-grey" @keyup.enter="criarConta" ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text v-else>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions v-if="!loader">
          <v-spacer></v-spacer>
          <v-btn color="cyan darken-2" flat @click="dialogMigracao = false">Cancelar</v-btn>
          <v-btn color="cyan darken-2" flat @click="migrar">Migrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRecuperarSenha" max-width="500">
      <v-card class="pa-3">
        <h1 class="text-xs-center headline pa-3">Insira seu email para recuperação de senha:</h1>
        <v-text-field
          color="blue-grey"
          class="pl-3 pr-3"
          label="Confirme seu email de acesso"
          box
          v-model="emailRecuperacao"
        ></v-text-field>
        <v-btn
          :loading="isLoadingRecuperarSenha"
          :disabled="isLoadingRecuperarSenha"
          class="white--text mb-3"
          style="background-color: #59BDB3"
          block
          large
          round
          @click="recuperacao()"
        >
          Enviar
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>
          </template>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sheet" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="fundo" tabs>
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edição de usuário</v-toolbar-title>
          <template v-slot:extension>
            <v-tabs v-model="tab" color="fundo" align-with-title>
              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
              <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
            </v-tabs>
          </template>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              color="teal lighten-5"
              :disabled="!fieldsValidation"
              dark
              flat
              @click="update"
            >Atualizar</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <p v-if="grupoUsuario === null">
                  Buscando dados protáxi...
                  <v-progress-circular :indeterminate="true" color="teal"></v-progress-circular>
                </p>

                <div v-if="isProtaxi" class="mt-5 mb-3">
                  <h2>Configuração Protáxi</h2>

                  <v-text-field
                    box
                    color="teal"
                    label="Áudio Cliente"
                    v-model="clientSelected.protaxi.audio_cliente"
                  ></v-text-field>
                  <v-text-field
                    box
                    color="teal"
                    label="Áudio Motorista"
                    v-model="clientSelected.protaxi.audio_motorista"
                  ></v-text-field>
                  <v-text-field
                    box
                    color="teal"
                    label="CallerID"
                    v-model="clientSelected.protaxi.callerid"
                  ></v-text-field>
                  <v-text-field
                    box
                    color="teal"
                    label="Voip Passageiro"
                    v-model="clientSelected.protaxi.voip_passageiro"
                  ></v-text-field>
                  <v-text-field
                    box
                    color="teal"
                    label="Voip Motorista"
                    v-model="clientSelected.protaxi.voip_motorista"
                  ></v-text-field>
                </div>

                <v-card-title>
                  <h2>Usuário</h2>
                </v-card-title>
                <v-text-field
                  readonly
                  box
                  color="teal"
                  label="Nome"
                  v-model="clientSelected.firstname"
                ></v-text-field>
                <v-text-field
                  readonly
                  box
                  color="teal"
                  label="Email"
                  v-model="clientSelected.email"
                ></v-text-field>
                <v-text-field
                  readonly
                  box
                  color="teal"
                  label="Telefone"
                  v-model="clientSelected.phone"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-alert
              class="ma-5"
              :value="grupoUsuario === false"
              color="warning"
              icon="priority_high"
              outline
            >Usuário não possui grupo de permissões</v-alert>

            <h3 class="ma-5" v-if="grupoUsuario === null">
              Buscando grupo do usuário...
              <v-progress-linear color="blue-grey" :indeterminate="true"></v-progress-linear>
            </h3>

            <v-card v-if="grupoUsuario !== false && grupoUsuario !== null" flat>
              <v-card-title>
                <h2>Edição de Grupo</h2>
              </v-card-title>
              <v-card-text>
                <div class="pa-2">
                  <v-text-field label="Nome do grupo" color="blue-grey" v-model="grupoUsuario.nome"></v-text-field>
                  <v-data-table
                    class="elevation-1"
                    :headers="headersAcoes"
                    :items="grupoUsuario.paginas"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.nome }}</td>
                      <td class="text-xs-left">
                        <p>
                          <v-switch
                            color="teal darken-3"
                            v-for="(a,i) in props.item.acoes"
                            :key="i"
                            :label="a.text"
                            v-model="a.status"
                            style="float:left;margin-right:20px;margin-top: 20px;"
                          ></v-switch>
                        </p>
                      </td>
                    </template>
                  </v-data-table>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="teal" dark @click="updateGroup">Atualizar grupo</v-btn>
                  </v-card-actions>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="pa-3">
              <v-card-title>
                <h2>Edição de Operadora</h2>
              </v-card-title>
              <v-alert
                v-if="!clientSelected.hasOwnProperty('migrated')"
                class="ma-3"
                :value="!clientSelected.hasOwnProperty('migrated')"
                color="warning"
                icon="priority_high"
                outline
              >Usuário não foi migrado</v-alert>
              <div
                v-if="clientSelected.hasOwnProperty('migrated') && clientSelected.migrated === true"
              >
                <v-flex xs4>
                  <v-select
                    box
                    label="Operadora"
                    color="teal"
                    :items="operadoras"
                    item-text="text"
                    item-value="value"
                    v-model="clientSelected.operator"
                  ></v-select>
                </v-flex>
                <v-btn round color="fundo" class="ml-0" @click="alteraOperadora">Alterar</v-btn>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="pa-3">
              <v-card-title>
                <h2>Alterar número mínimo de SMS para notificação</h2>
              </v-card-title>
              <v-alert
                v-if="!clientSelected.hasOwnProperty('migrated')"
                class="ma-3"
                :value="!clientSelected.hasOwnProperty('migrated')"
                color="warning"
                icon="priority_high"
                outline
              >Usuário não foi migrado</v-alert>
              <div
                v-if="clientSelected.hasOwnProperty('migrated') && clientSelected.migrated === true"
              >
                <v-flex xs4>
                  <v-text-field
                    box
                    label="Número mínimo de SMS"
                    color="teal"
                    v-model="clientSelected.smsMin"
                  ></v-text-field>
                </v-flex>
                <v-btn round color="fundo" class="ml-0" @click="alteraSmsMin">Alterar</v-btn>
              </div>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat class="pa-3">
                <v-card-title>
                    <h2>Rotas de integração com Whatsapp</h2>
                </v-card-title>

                <v-alert
                    v-if="!clientSelected.hasOwnProperty('migrated')"
                    class="ma-3"
                    :value="!clientSelected.hasOwnProperty('migrated')"
                    color="warning"
                    icon="priority_high"
                    outline
                >Usuário não foi migrado</v-alert>

                <div v-if="clientSelected.hasOwnProperty('migrated') && clientSelected.migrated === true">
                    <v-flex>
                        <v-switch
                            :loading="loadingWhatsInteg"
                            :disabled="loadingWhatsInteg"
                            class="mx-3"
                            v-model="clientSelected.whatsapp_integration.enabled"
                            :label="clientSelected.whatsapp_integration.enabled ? 'Habilitado' : 'Habilitar'"
                        ></v-switch>
                        <v-data-table v-if="clientSelected.whatsapp_integration.enabled" :items="empresaFromUser?empresaFromUser.configurations.whatsapp_integrations:[]" :headers="headersWhatsInt" hide-actions>
                            <template v-slot:items="props">
                                <td class="text-xs-center">{{ props.item.application }}</td>
                                <td class="text-xs-center">{{ props.item.domain }}</td>
                                <td class="text-xs-center">{{ props.item.token }}</td>
                                <td class="text-xs-center">
                                    <v-icon
                                        color="#00897b"
                                        v-if="clientSelected.whatsapp_integration.data && clientSelected.whatsapp_integration.data.token === props.item.token "
                                    >check</v-icon>
                                    <v-btn
                                        v-else
                                        flat
                                        style="background: #00897b; color: #fff"
                                        @click="selectRouteWhatsapp(props.item)"
                                        :loading="loadingSelectRouteWhats"
                                    >
                                        selecionar
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import CriarConta from "../CriarConta_OLD";
import Mask from "../../helpers/Mask";
import getCep from "../../helpers/GetCep";
import cpfCnpj from "./../../helpers/CpfCnpj";
import { mapActions } from "vuex";
import validaNumber from "../../helpers/validaNumber";
export default {
  mixins: [Mask],
  components: {
    CriarConta
  },
  data() {
    return {
      pessoalInterno:["Luiz","Sara","Fernando","Gil","Soriano","Lucas","Maria"],
      testeSms: {
        phone: [],
        text: "",
        isPush: false,
        captura: false
      },
      user_token: null,
      novoCliente: false,
      modalTesteSms: false,
      telefones: [],
      usuariosInternos: [],
      tab: null,
      isProtaxi: false,
      items: [
        "Editar Usuário",
        "Editar Grupo",
        "Alterar Operadora",
        "Notificação de SMS",
        "Integração com Whatsapp"
      ],
      userSelected: {},
      clientSelected: {
        protaxi: {}
      },
      grupoUsuario: null,
      novoSaldo: "",
      quemAddSaldo: "",
      dialogMigracao: false,
      dialogRecuperarSenha: false,
      sheet: false,
      showPass: false,
      loader: false,
      expand: false,
      isLoadingCahngeSaldo: false,
      isLoadingRecuperarSenha: false,
      modalSaldo: false,
      emailRecuperacao: "",
      user: {
        nome: "",
        cep: "",
        telefone: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        email: "",
        senha: "",
        numero: "",
        senhaNovamente: "",
        cpf_cpnj: "",
        _id: ""
      },
      search: "",
      headersAcoes: [
        { text: "Nome da página", value: "nome", sortable: false },
        { text: "Ações", value: "acoes", sortable: false }
      ],
      operadoras: [
        { text: "Fusion", value: "Fusion" },
        { text: "DisparoPRO", value: "disparopro" },
        { text: "Fusion Long", value: "FusionLong" },
        { text: "Movile", value: "movile" },
        { text: "Movile Prioritaria", value: "movile_prioritaria" },
        { text: "Telintel", value: "telintel" },
        { text: "BestVoice", value: "bestvoice" },
        { text: "Chipeira", value: "chipeira" },
        { text: "HubPush", value: "hubpush" },
        { text: "Whatsapp", value: "whatsapp" }
      ],
      headers: [
        {
          text: "Nome da Empresa",
          align: "left",
          value: "firstname",
          sortable: false
        },
        { text: "Créditos", align: "left", value: "credits", sortable: true },
        { text: "Email", align: "left", value: "email", sortable: false },
        { text: "Status", align: "center", value: "status", sortable: false },
        { text: "Senha", align: "center", value: "acoes", sortable: false },
        {
          text: "Teste de Envio",
          align: "center",
          value: "operator",
          sortable: false
        },
        { text: "Ações", align: "center", value: "acoes", sortable: false }
      ],
      empresaFromUser: null,
      headersWhatsInt: [
        { text: "Aplicação",    value: "application",   sortable: false,    align: 'center' },
        { text: "Domínio",      value: "domain",        sortable: false,    align: 'center' },
        { text: "Token",        value: "token",         sortable: false,    align: 'center' },
        { text: "Selecionado",  value: "selected",      sortable: false,    align: 'center' }
      ],
      loadingWhatsInteg: false,
      whatsEnabled: false,
      loadingSelectRouteWhats: false
    };
  },
  mounted() {
    this.loadUsuarios();
  },
  methods: {
    ...mapActions([
      "loadUsuariosAstandes",
      "migraUsuario",
      "redefineSenha",
      "updateSaldo",
      "updateCliente",
      "loadGrupos",
      "updateProtaxi",
      "updateUserGroup",
      "updateOperator",
      "updateSmsMinNotify",
      "sendSms",
      "listaRotasWhatsapp",
      "updateWhatsappIntegration"
    ]),

    closeDialog() {
        this.sheet = false
        this.loadUsuarios()
    },

    async getEmpresaById(email) {
        const { status, empresa } = await this.listaRotasWhatsapp(email)
        status && (this.empresaFromUser = empresa)
    },

    async selectRouteWhatsapp(route) {
        this.loadingSelectRouteWhats = true

        const { status, message } = await this.updateWhatsappIntegration({
            whatsapp_integration: {
                ...this.clientSelected.whatsapp_integration,
                data: route
            },
            user_id: this.clientSelected._id
        })

        if(status) {
            this.clientSelected.whatsapp_integration.data = route
            this.$eventHub.$emit('snackBar', {color: 'success', message: 'Rote de envio por Whatsapp atualizado com sucesso.' })
        } else {
            this.$eventHub.$emit('snackBar', {color: 'error', message })
        }

        this.loadingSelectRouteWhats = false
    },

    async send() {
      if (this.getValidaNumber(this.testeSms.phone)) {
        let resp = await this.sendSms({sms: this.testeSms, user_id: this.user_token});
        this.$eventHub.emit("snackBar", { message: resp.mensagem });
        this.modalTesteSms = false
        this.testeSms = {
          phone: [],
          text: "",
          isPush: false,
          captura: false
        };
      } else {
        this.$eventHub.emit("snackBar", { message: "Número inválido" });
      }
    },
    getValidaNumber(number) {
      return validaNumber(number);
    },
    async updateGroup() {
      let result = await this.updateUserGroup(this.grupoUsuario);
      if (result.status) {
        this.grupoUsuario =
          (await this.loadGrupos(this.clientSelected._id)) || false;
        this.isProtaxi = this.verificaProtaxi();
        this.$eventHub.$emit("snackBar", {
          color: "success",
          message: result.message
        });
      } else
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: result.message
        });
    },
    verificaProtaxi() {
      if (this.grupoUsuario === false) return false;
      if (this.grupoUsuario !== null)
        return this.$can("menuprotaxi", null, this.grupoUsuario.paginas);
    },
    async update() {
      this.clientSelected.root_id = this.$store.getters.getUser._id;
      //let result = await this.updateCliente(this.clientSelected)
      let {
        voip_motorista,
        audio_cliente,
        audio_motorista,
        callerid,
        voip_passageiro
      } = this.clientSelected.protaxi;
      let resultProtaxi = await this.updateProtaxi({
        voip_motorista,
        audio_cliente,
        audio_motorista,
        callerid,
        voip_passageiro,
        _id: this.clientSelected._id
      });

      if (resultProtaxi.status) {
        this.loadUsuarios();
        this.$eventHub.$emit("snackBar", {
          color: "success",
          message: resultProtaxi.mensagem
        });
        this.sheet = false;
      } else
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: resultProtaxi.mensagem
        });
    },
    async loadUsuarios() {
      this.usuariosInternos = await this.loadUsuariosAstandes();
    },
    async alterarSaldo() {
        this.isLoadingCahngeSaldo   = true
        let saldo                   = {};
        saldo.usuario               = this.userSelected._id;
        saldo.credits               = this.novoSaldo;
        saldo.nome                  = this.quemAddSaldo;

        let result = await this.updateSaldo(saldo);

        if (result.status) {
            this.loadUsuarios();
            this.$eventHub.$emit("snackBar", {
                color: "success",
                message: result.mensagem
            });
            this.modalSaldo     = false;
        } else {
            this.$eventHub.$emit("snackBar", {
                color: "error",
                message: result.mensagem
            });
        }

        this.isLoadingCahngeSaldo = false
    },
    async alteraOperadora() {
        if(this.clientSelected.operator === 'whatsapp'){
            if(!this.clientSelected.whatsapp_integration.enabled) {
                return this.$eventHub.$emit("snackBar", {
                    color: "warning",
                    message: 'Para selecionar opção Whatsapp é necessário habilitar esse cliente na aba "Integração com Whatsapp"',
                    timeout: 10000
                });
            } else {
                if(!this.clientSelected.whatsapp_integration.data) {
                    return this.$eventHub.$emit("snackBar", {
                        color: "warning",
                        message: 'Falta escolher uma rota de envio no Whatsapp na aba "Integração com Whatsapp"',
                        timeout: 10000
                    });
                }
            }
        }

        let result = await this.updateOperator({
            _id: this.clientSelected._id,
            operator: this.clientSelected.operator
        });
        if (result.status) {
            this.$eventHub.$emit("snackBar", {
            color: "success",
            message: result.mensagem
            });
            this.sheet = false;
        } else
            this.$eventHub.$emit("snackBar", {
            color: "error",
            message: result.mensagem
        });
    },
    async alteraSmsMin() {
      let result = await this.updateSmsMinNotify({
        _id: this.clientSelected._id,
        smsMin: this.clientSelected.smsMin
      });
      if (result.status) {
        this.$eventHub.$emit("snackBar", {
          color: "success",
          message: result.mensagem
        });
        this.sheet = false;
      } else
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: result.mensagem
        });
    },
    comprimeNome(nome, sobrenome) {
      let nomeCompleto = nome + " " + sobrenome;
      return nomeCompleto.substr(0, 10) + "...";
    },
    abreSaldo(item) {
      this.modalSaldo = true;
      this.novoSaldo = "";
      this.userSelected = item;
    },
    async editItem(item) {
      this.grupoUsuario = null;
      if (!item.protaxi) item.protaxi = {};
      this.sheet = true;
      this.clientSelected = Object.assign({}, item);
      this.grupoUsuario = (await this.loadGrupos(item._id)) || false;
      this.isProtaxi = this.verificaProtaxi();
      //console.log(this.clientSelected.email)
      this.getEmpresaById(this.clientSelected.email)

      //this.root_loadGruposByEmpresa_id(this.clientSelected.id)
    },
    showDialogMigracao(user) {
      this.user.nome = user.firstname + " " + user.lastname;
      this.user.email = user.email;
      this.user.telefone = user.phone;
      this.user._id = user._id;
      this.dialogMigracao = true;
      //this.migraUsuario(user._id)
    },
    async buscarCep() {
      try {
        let dadosCep = await getCep(this.user.cep);
        if (dadosCep.cep) {
          this.user.bairro = dadosCep.bairro;
          this.user.logradouro = dadosCep.logradouro;
          this.user.estado = dadosCep.uf;
          this.user.cidade = dadosCep.localidade;
        } else {
          this.reset();
        }
      } catch (e) {
        this.reset();
      }
    },
    async migrar() {
      this.loader = true;
      if (
        this.user.cep &&
        this.user.logradouro &&
        this.user.bairro &&
        this.user.cidade &&
        this.user.estado &&
        this.user.email &&
        this.user.senha &&
        this.user.numero &&
        this.user.senhaNovamente &&
        this.user.cpf_cpnj
      ) {
        if (this.user.senha == this.user.senhaNovamente) {
          if (cpfCnpj(this.user.cpf_cpnj) != 0) {
            let res = await this.migraUsuario(this.user);
            if (res.status) {
              this.loader = false;
              this.resetAll();
              this.dialogMigracao = false;
              this.$eventHub.$emit("snackBar", {
                color: "success",
                message: res.mensagem
              });
              this.usuariosInternos = await this.loadUsuariosAstandes();
            } else {
              this.loader = false;
              this.$eventHub.$emit("snackBar", {
                color: "error",
                message: res.mensagem
              });
            }
          } else {
            this.loader = false;
            this.$eventHub.$emit("snackBar", {
              color: "error",
              message: "CPF ou CNPJ inválidos"
            });
          }
        } else {
          this.loader = false;
          this.$eventHub.$emit("snackBar", {
            color: "error",
            message: "Senhas não conferem"
          });
        }
      } else {
        this.loader = false;
        this.$eventHub.$emit("snackBar", {
          color: "error",
          message: "Preencha todos os campos"
        });
      }
    },
    showDialogReset(email) {
      this.dialogRecuperarSenha = true;
      this.emailRecuperacao = email;
    },
    async recuperacao() {
      this.isLoadingRecuperarSenha = true;
      let result = await this.redefineSenha(this.emailRecuperacao);
      if (result.status) {
        this.isLoadingRecuperarSenha = false;
        this.$eventHub.$emit("snackBar", {
          color: "success",
          message: result.message
        });
        this.dialogRecuperarSenha = false;
      } else {
        this.isLoadingRecuperarSenha = false;
        this.dialogRecuperarSenha = false;
      }
    },
    resetAll() {
      this.user = {
        nome: "",
        cep: "",
        telefone: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        email: "",
        senha: "",
        numero: "",
        senhaNovamente: "",
        cpf_cpnj: ""
      };
    },
    reset() {
      this.user.bairro = "";
      this.user.logradouro = "";
      this.user.estado = "";
      this.user.cidade = "";
    }
  },
    computed: {
        fieldsValidation() {
            if (!this.clientSelected.protaxi) return false;
            let {
            voip_motorista,
            audio_cliente,
            audio_motorista,
            callerid,
            voip_passageiro
            } = this.clientSelected.protaxi;
            /*return !!( firstname && phone && /^[a-z0-9._]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test( email ) &&
            ( this.isProtaxi === true ? voip_motorista && audio_cliente && callerid &&  voip_passageiro : true  ) )*/
            return !!(this.isProtaxi === true
            ? voip_motorista &&
                audio_cliente &&
                audio_motorista &&
                callerid &&
                voip_passageiro
            : false);
        }
    },
    watch: {
        "user.cep"() {
            if (this.user.cep.length >= 8) {
            this.buscarCep();
            } else {
            this.reset();
            }
        },

        async "clientSelected.whatsapp_integration.enabled"(val, oldval) {
            console.log(val, oldval)
            if(oldval !== undefined && val !== oldval) {
            this.loadingWhatsInteg = true

            const { status, message } = await this.updateWhatsappIntegration({
                whatsapp_integration: {
                    ...this.clientSelected.whatsapp_integration,
                    enabled: this.clientSelected.whatsapp_integration.enabled
                },
                user_id: this.clientSelected._id
            })

            if(status) {
                this.$eventHub.$emit('snackBar', {color: 'success', message })
            } else {
                this.$eventHub.$emit('snackBar', {color: 'error', message })
                this.clientSelected.whatsapp_integration.enabled = !this.clientSelected.whatsapp_integration.enabled
            }

            this.loadingWhatsInteg = false
            }
        },

        modalSaldo(val) {
            if(!val) {
                this.userSelected           = {}
                this.novoSaldo              = ""
                this.quemAddSaldo           = ""
                this.isLoadingCahngeSaldo   = false
            }
        }

        /*async tab()
        {
            if( this.items[ this.tab ] == "Editar Usuário" )
            {
                console.log( "ok" )
                this.grupoUsuario = await this.loadGrupos( this.clientSelected._id) || false
                this.isProtaxi    = this.verificaProtaxi()
            }
        }*/
    }
};
</script>



// WEBPACK FOOTER //
// src/components/root/ListarClientes.vue